module.exports = __webpack_public_path__ + "img/siq-m-222.1adef39.webp";